/**
 * Concatenate series of url definitions into a URL.
 *
 * This is originally used for SEO purposes, to help splits the Ford host literal string
 * into pieces, it helps avoid Google crawling and intepreting said string as actual link
 * from AT/KBB to Ford site.
 * @param
 * @property  {String} protocol The HTTP or HTTPS protocol followed by '://'
 * @property  {Array} domain Array of domain strings
 * @property  {Array} pathname Array of pathname strings
 * @returns {String} URL string
 */
export default function joinSplitSeoUrl(_temp) {
  let {
    protocol,
    host = [],
    pathname = [],
    trailingSlash
  } = _temp === void 0 ? {} : _temp;
  const segments = [];
  if (protocol) {
    segments.push(protocol);
  }
  if (host.length) {
    segments.push(host.join('.'));
  }
  if (pathname.length) {
    segments.push(['/', ...pathname].join('/'));
  }
  if (trailingSlash) {
    segments.push('/');
  }
  return segments.join('').replace(/(?<!:)(\/{2,})/g, '/').replaceAll(/\.+/g, '.');
}